<template>
  <b-form @submit.prevent="guardar">
    <b-form-row>
      <!-- Punto de inflamación -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion5"
        input_text="Punto de inflamación"
        v_model_range="punto_inflamacion_rango"
        v_model="punto_inflamacion"
        :required="true"
        v_model_up_to="punto_inflamacion_hasta"
        v_model_um="id_um_punto_inflamacion"
        um_type="UTEMP"
        :values="selectedSeccion5"
      />
      <!-- Limite inferior y superior de inflamabilidad -->
      <b-form-group class="col-md-6">
        <label for="limite_inf_sup_inflamabilidad">
          Límite inferior y superior de inflamabilidad <span style="color: red">(*)</span>
        </label>
        <b-form-input id="limite_inf_sup_inflamabilidad"
                      name="limite_inf_sup_inflamabilidad"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion5.limite_inf_sup_inflamabilidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.limite_inf_sup_inflamabilidad')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <!-- Temperatura de ignición espontánea -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion5"
        input_text="Temperatura de ignición espontánea"
        v_model_range="temperatura_ignicion_espontanea_rango"
        v_model="temperatura_ignicion_espontanea"
        :required="true"
        v_model_up_to="temperatura_ignicion_espontanea_hasta"
        v_model_um="id_um_temperatura_ignicion_espontanea"
        um_type="UTEMP"
        :values="selectedSeccion5"
      />
      <b-form-group class="col-md-6">
        <label for="medios_extincion">
          Medios de extinción <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="medios_extincion"
                         name="medios_extincion"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion5.medios_extincion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion5.medios_extincion')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="procedimiento">
          Procedimiento en caso de incendio y/o explosión <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="procedimiento"
                         name="procedimiento"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion5.procedimiento"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion5.procedimiento')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="productos_combustion">
          Productos de la combustión <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="productos_combustion"
                         name="productos_combustion"
                         data-vv-as=" "
                         v-model="selectedSeccion5.productos_combustion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion5.productos_combustion')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <b-form-group class="col-md-6">
        <label for="medidas_especiales">
          Medidas especiales que deben de tomar los equipos de lucha contra incendios <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="medidas_especiales"
                         name="medidas_especiales"
                         data-vv-as=" "
                         v-model="selectedSeccion5.medidas_especiales"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion5.medidas_especiales')"
        />
      </b-form-group>
    </b-form-row>

    <hr>
    <FooterButtons back="/fds/listar" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import BInputUm from "@/views/fds/componentes/BInputUm.vue";

export default {
  name: "FDS-Seccion5",
  components: {
    BInputUm,
    FooterButtons
  },
  data() {
    return {
    }
  },
  async created() {
    await this.setSeccionActual(5);
    await this.obtenerUnidadesDeTemperatura();
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion'
    ]),
    ...mapActions('propiedades', [
      'obtenerUnidadesDeTemperatura',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion5'
    ]),
    ...mapState('propiedades', [
      'unidades_de_temperatura',
    ]),
  }
}
</script>
